import TrelloCard from './TrelloCard';

export default TrelloCard;
